// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { Cart } from "@insite/client-framework/Services/CartService";
import {
    canCheckoutWithCart,
    hasOnlyQuoteRequiredProducts,
    isCartCheckoutDisabled,
} from "@insite/client-framework/Store/Data/Carts/CartsSelector";

export const isCheckoutDisabledHandler = (cart: Cart | undefined) => {
    // const isPricingZero = cart?.cartLines?.filter(cartLine => cartLine.pricing?.unitNetPrice === 0);
    return !canCheckoutWithCart(cart) || hasOnlyQuoteRequiredProducts(cart) || isCartCheckoutDisabled(cart);
};

export function isValidDate(blackOutDays: string[], currentDate: Date) {
    const todayDate = new Date();
    return (
        currentDate.getDay() !== 0 &&
        currentDate.getDay() !== 6 &&
        !blackOutDays.find((item: string) => new Date(item).toDateString() === currentDate.toDateString()) &&
        currentDate.getTime() > todayDate.getTime()
    );
}

export const areObjectValuesNotEmpty = (obj: Object) => Object.values(obj).some(value => value !== "");

export const parseBoolean = (value?: string) => (value ? value?.toLowerCase() === "true" : false);

/**
 * Helper function to export data to csv file
 * @param fields
 * @param data
 * @param filename
 */
export const exportToCSV = async (fields: string[], data: (string | number | null)[][], filename?: string) => {
    const dataForUnparse = {
        fields,
        data,
    };

    const { unparse } = await import(/* webpackChunkName: "papaparse" */ "papaparse");
    const csv = unparse(dataForUnparse);
    const csvBlob = new Blob([`\uFEFF${csv}`], { type: "text/csv;charset=utf-8;" });
    const fileName = `${filename || "csv_exported_file"}_${Math.random() * 10000}.csv`;
    const downloadLink = document.createElement("a");
    downloadLink.href = window.URL.createObjectURL(csvBlob);
    downloadLink.setAttribute("download", fileName);
    downloadLink.click();
};